import React from 'react';
import { motion } from 'framer-motion';
import { jobs } from '../data/hrData';
import Badge from './ui/Badge';
import Button from './ui/Button';
import { MapPin as _lr_MapPin, DollarSign as _lr_DollarSign, Users as _lr_Users, Calendar as _lr_Calendar } from 'lucide-react';

const MapPin = _lr_MapPin || (() => null);
const DollarSign = _lr_DollarSign || (() => null);
const Users = _lr_Users || (() => null);
const Calendar = _lr_Calendar || (() => null);
export function JobList() {
  return (
    <motion.div initial={{ opacity: 1 }} animate={{ opacity: 1 }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {jobs.map((job, i) => (
        <motion.div key={job.id} initial={{ opacity: 1, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.07 }}
          className="bg-white rounded-xl border border-gray-200 p-5 hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
          <div className="flex items-start justify-between mb-3">
            <div>
              <h3 className="font-semibold text-gray-900 text-sm">{job.title}</h3>
              <p className="text-xs text-gray-500 mt-0.5">{job.department}</p>
            </div>
            <Badge variant={job.status === 'Active' ? 'success' : 'default'}>{job.status}</Badge>
          </div>
          <div className="space-y-1.5 mb-4">
            <div className="flex items-center gap-1.5 text-xs text-gray-500"><MapPin size={12} className="text-purple-400" />{job.location}</div>
            <div className="flex items-center gap-1.5 text-xs text-gray-500"><DollarSign size={12} className="text-purple-400" />{job.salary}</div>
            <div className="flex items-center gap-1.5 text-xs text-gray-500"><Users size={12} className="text-purple-400" />{job.applicants} applicants</div>
            <div className="flex items-center gap-1.5 text-xs text-gray-500"><Calendar size={12} className="text-purple-400" />Posted {job.postedDate}</div>
          </div>
          <div className="flex flex-wrap gap-1 mb-4">
            {(job.skills || []).map(s => <span key={s} className="text-xs bg-purple-50 text-purple-700 px-2 py-0.5 rounded-full">{s}</span>)}
          </div>
          <div className="flex gap-2">
            <Button size="sm" className="flex-1">View Applicants</Button>
            <Button size="sm" variant="outline">Edit</Button>
          </div>
        </motion.div>
      ))}
    </motion.div>
  );
}

export default JobList;